import Button from "@/common/button/button"
import Magnifier from "@/common/icons/magnifier"
import Close from "@/common/icons/close"
import { useEffect } from "react"
import { FormProvider, useForm } from "react-hook-form"
import { ActivityControl } from "../wild-neighbors-register/activity-control/activity-control"
import Select from "@/components/common/form/select"
import styles from "./filter.module.css"

export function Filter({ block, setSearch, setGrade, setActivities }) {
  const methods = useForm({
    defaultValues: {
      search: "",
      grade: "0",
      activity: []
    },
    mode: "onChange"
  })
  const { register, control, watch, resetField, handleSubmit } = methods
  const onSubmit = (e) => {
    setSearch(e.search)
    setGrade(e.grade)
    setActivities(e.activity)
  }

  const grades = [
    {
      name: "Alla årskurser",
      value: "0"
    },
    {
      name: "Förskola",
      value: "Förskola"
    },
    {
      name: "Åk F-3",
      value: "Åk F-3"
    },
    {
      name: "Åk 4-6",
      value: "Åk 4-6"
    },
    {
      name: "Åk 7-9",
      value: "Åk 7-9"
    },
    {
      name: "Fritids",
      value: "Fritids"
    }
  ]

  useEffect(() => {
    watch((data) => {
      setActivities(data.activity)
    })
  }, [watch, setActivities])

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)} className={styles.wrapper}>
        <div className="search-field">
          <Magnifier className="w-5 mr-4 fill-current stroke-current" />
          <input
            type="text"
            placeholder="Sök skola eller klass"
            {...register("search")}
          />
          {watch("search").length > 0 && (
            <div
              className="clear-search"
              onClick={(e) => {
                e.stopPropagation()
                resetField("search")
                setSearch("")
              }}>
              <Close />
            </div>
          )}
        </div>
        <div className="grade-filter">
          <Select name="grade" options={grades}></Select>
        </div>
        <div className="activitites-filter">
          <ActivityControl
            options={block.attrs?.activities ?? []}
            control={control}
            name="activity"
            placeholder={block.attrs?.placeholder ?? "Välj aktivitet"}
            multiple={true}
          />
        </div>
        <Button ariaLabel="Sök" theme="lime" type="submit" className="min-w-32">
          Sök
        </Button>
      </form>
    </FormProvider>
  )
}
